/**
 * textNormalize.ts
 *
 * Shared utility for normalizing free-text inputs entered by the user.
 * Apply whenever a text edit is confirmed (blur, Enter, form submit).
 * Excluded: numeric, date, boolean, and select/dropdown inputs.
 */

/**
 * Trim leading/trailing whitespace and collapse consecutive horizontal spaces
 * to a single space while preserving line breaks (`\n`).
 */
export function normalizeText(s: string): string {
  if (s.includes('\n')) {
    return s
      .split('\n')
      .map((line) => line.trim().replace(/[^\S\r\n]+/g, ' '))
      .join('\n')
      .trim()
  }
  return s.trim().replace(/\s+/g, ' ')
}
